/**
* Logos Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logos Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'logos-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.logos-slider' ).each( function() {
        $( this ).find( '.slider' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( this ).find( '.prev-slide' )[0],
          nextArrow: $( this ).find( '.next-slide' )[0],
          slidesToShow: 5,
          centerMode: false,
          responsive: [
            {
              breakpoint: 1270,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                centerMode: true,
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                centerMode: true,
                slidesToShow: 1,
              },
            },
          ],
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logos-slider', COMPONENT );
} )( app );
